const routerReports = [
  {
    path: "/relatorio/empresas",
    name: "ReportFranchise",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ReportFranchise" */ "@/views/Reports/Franchise.vue"
      ),
  },
  {
    path: "/relatorio/royalties",
    name: "ReportRoyalties",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ReportRoyalties" */ "@/views/Reports/Royalties.vue"
      ),
  },
  {
    path: "/relatorio/produtos",
    name: "ReportProducts",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ReportProducts" */ "@/views/Reports/Product.vue"
      ),
  },
  {
    path: "/relatorio/precos",
    name: "ReportPrices",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ReportPrices" */ "@/views/Reports/Price.vue"
      ),
  },
  {
    path: "/relatorio/pedidos",
    name: "OrderReport",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "OrderReport" */ "@/views/Reports/Order.vue"),
  },
  {
    path: "/relatorio/cores",
    name: "ColorReport",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ColorReport" */ "@/views/Reports/Color.vue"),
  },
  {
    path: "/relatorio/materiais",
    name: "MaterialReport",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "MaterialReport" */ "@/views/Reports/Material.vue"
      ),
  },
  {
    path: "/relatorio/publicacoes",
    name: "PublicationReport",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PublicationReport" */ "@/views/Reports/Publication.vue"
      ),
  },
  {
    path: "/relatorio/produtos-omie",
    name: "ProductsExportOmie",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductsExportOmie" */ "@/views/Reports/ProductsExportOmie.vue"
      ),
  },
  {
    path: "/relatorio/faturas-backup",
    name: "InvoicesBackup",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "InvoicesBackup" */ "@/views/Reports/InvoicesBackup.vue"
      ),
  },
];

export default routerReports;
